"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegionsManager = void 0;

var Point2D_1 = require("../Core/Point2D");

var Rect_1 = require("../Core/Rect");

var IRegionCallbacks_1 = require("../Interface/IRegionCallbacks");

var RectRegion_1 = require("./Rect/RectRegion");

var PointRegion_1 = require("./Point/PointRegion");

var PolygonRegion_1 = require("./Polygon/PolygonRegion");

var PolylineRegion_1 = require("./Polyline/PolylineRegion");

var RegionMenu_1 = require("./RegionMenu");

var RegionData_1 = require("../Core/RegionData");
/**
 * The manager for visual region objects.
 */


var RegionsManager = /*#__PURE__*/function () {
  /**
   * Creates new `RegionsManager`.
   * @param svgHost - The hosting SVG element.
   * @param callbacks - Reference to the callbacks collection.
   */
  function RegionsManager(svgHost, callbacks) {
    var _this = this;

    _classCallCheck(this, RegionsManager);

    /**
     * Global freezing state.
     */
    this.isFrozenState = false;
    /**
     * Internal manipulation flag.
     */

    this.justManipulated = false;
    /**
     * Internal flag for locking manipulation.
     */

    this.manipulationLock = false;
    /**
     * Tags create/redraw options.
     */

    this.tagsUpdateOptions = {
      showRegionBackground: true
    };
    this.baseParent = svgHost;
    this.paper = Snap(svgHost);
    this.paperRect = new Rect_1.Rect(svgHost.width.baseVal.value, svgHost.height.baseVal.value);
    this.regions = new Array();
    this.callbacks = {
      onChange: function onChange(region, regionData, state) {
        var multiSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _this.onRegionChange(region, regionData, state, multiSelection);

        if (typeof callbacks.onChange === "function") {
          callbacks.onChange(region, regionData, state, multiSelection);
        }
      },
      onManipulationLockRequest: function onManipulationLockRequest(region) {
        _this.manipulationLock = true;

        if (typeof callbacks.onManipulationLockRequest === "function") {
          callbacks.onManipulationLockRequest(region);
        }
      },
      onManipulationLockRelease: function onManipulationLockRelease(region) {
        _this.manipulationLock = false;

        if (typeof callbacks.onManipulationLockRelease === "function") {
          callbacks.onManipulationLockRelease(region);
        }
      },
      onManipulationBegin: this.functionGuard(callbacks.onManipulationBegin),
      onManipulationEnd: function onManipulationEnd(region) {
        if (!_this.manipulationLock && typeof callbacks.onManipulationEnd === "function") {
          callbacks.onManipulationEnd(region);
        }
      },
      onRegionDelete: this.functionGuard(callbacks.onRegionDelete),
      onRegionMoveBegin: this.functionGuard(callbacks.onRegionMoveBegin),
      onRegionMove: this.functionGuard(callbacks.onRegionMove),
      onRegionMoveEnd: this.functionGuard(callbacks.onRegionMoveEnd),
      onRegionSelected: this.functionGuard(callbacks.onRegionSelected)
    };
    this.buildOn(this.paper);
    this.subscribeToEvents();
  }
  /**
   * Returns current freezing state.
   */


  _createClass(RegionsManager, [{
    key: "addRegion",

    /**
     * Add new region to the manager. Automatically defines region type based on the `type` property.
     * @param id - The region ID.
     * @param regionData - The `RegionData` object defining region.
     * @param tagsDescriptor - The tags descriptor object.
     */
    value: function addRegion(id, regionData, tagsDescriptor) {
      if (regionData.type === RegionData_1.RegionDataType.Point) {
        this.addPointRegion(id, regionData, tagsDescriptor);
      } else if (regionData.type === RegionData_1.RegionDataType.Polyline) {
        this.addPolylineRegion(id, regionData, tagsDescriptor);
      } else if (regionData.type === RegionData_1.RegionDataType.Rect) {
        this.addRectRegion(id, regionData, tagsDescriptor);
      } else if (regionData.type === RegionData_1.RegionDataType.Polygon) {
        this.addPolygonRegion(id, regionData, tagsDescriptor);
      }

      this.sortRegionsByArea();
      this.redrawAllRegions();
    }
    /**
     * Add new rect region to the manager.
     * @param id - The region ID.
     * @param regionData - The `RegionData` object defining region.
     * @param tagsDescriptor - The tags descriptor object.
     */

  }, {
    key: "addRectRegion",
    value: function addRectRegion(id, regionData, tagsDescriptor) {
      this.menu.hide();
      var region = new RectRegion_1.RectRegion(this.paper, this.paperRect, regionData, this.callbacks, id, tagsDescriptor, this.tagsUpdateOptions);
      this.registerRegion(region);
    }
    /**
     * Add new point region to the manager.
     * @param id - The region ID.
     * @param regionData - The `RegionData` object defining region.
     * @param tagsDescriptor - The tags descriptor object.
     */

  }, {
    key: "addPointRegion",
    value: function addPointRegion(id, regionData, tagsDescriptor) {
      this.menu.hide();
      var region = new PointRegion_1.PointRegion(this.paper, this.paperRect, regionData, this.callbacks, id, tagsDescriptor, this.tagsUpdateOptions);
      this.registerRegion(region);
    }
    /**
     * Add new polyline region to the manager.
     * @param id - The region ID.
     * @param regionData - The `RegionData` object defining region.
     * @param tagsDescriptor - The tags descriptor object.
     */

  }, {
    key: "addPolylineRegion",
    value: function addPolylineRegion(id, regionData, tagsDescriptor) {
      this.menu.hide();
      var region = new PolylineRegion_1.PolylineRegion(this.paper, this.paperRect, regionData, this.callbacks, id, tagsDescriptor, this.tagsUpdateOptions);
      this.registerRegion(region);
    }
    /**
     * Add new polygon region to the manager.
     * @param id - The region ID.
     * @param regionData - The `RegionData` object defining region.
     * @param tagsDescriptor - The tags descriptor object.
     */

  }, {
    key: "addPolygonRegion",
    value: function addPolygonRegion(id, regionData, tagsDescriptor) {
      this.menu.hide();
      var region = new PolygonRegion_1.PolygonRegion(this.paper, this.paperRect, regionData, this.callbacks, id, tagsDescriptor, this.tagsUpdateOptions);
      this.registerRegion(region);
    }
    /**
     * Redraws all regions. Reinserts regions in actual order.
     */

  }, {
    key: "redrawAllRegions",
    value: function redrawAllRegions() {
      var _this2 = this;

      // re-add all elements to DOM based on new order
      window.requestAnimationFrame(function (e) {
        _this2.regions.forEach(function (region) {
          var node = region.node.remove();

          _this2.regionManagerLayer.add(node);

          node.transform(_this2.currentRegionTransformation);
        });
      });
    }
    /**
     * Returns bounding boxes of the selected regions.
     * @deprecated Use `getSelectedRegions` method instead
     */

  }, {
    key: "getSelectedRegionsBounds",
    value: function getSelectedRegionsBounds() {
      var regions = this.lookupSelectedRegions().map(function (region) {
        return {
          id: region.ID,
          x: region.x,
          y: region.y,
          width: region.boundRect.width,
          height: region.boundRect.height
        };
      });
      return regions;
    }
    /**
     * Returns a collection of all the regions currently drawn on the canvas
     */

  }, {
    key: "getAllRegions",
    value: function getAllRegions() {
      return this.regions.map(function (region) {
        return {
          id: region.ID,
          tags: region.tags,
          regionData: region.regionData.copy()
        };
      });
    }
    /**
     * Returns a collection of selected regions.
     */

  }, {
    key: "getSelectedRegions",
    value: function getSelectedRegions() {
      return this.lookupSelectedRegions().map(function (region) {
        return {
          id: region.ID,
          tags: region.tags,
          regionData: region.regionData
        };
      });
    }
    /**
     * Deletes a region with specified `id`.
     * @param id - Id of the region to delete.
     */

  }, {
    key: "deleteRegionById",
    value: function deleteRegionById(id) {
      var region = this.lookupRegionByID(id);

      if (region != null) {
        this.deleteRegion(region);
      }

      this.callbacks.onManipulationEnd();
    }
    /**
     * Deletes all the regions from the manager.
     */

  }, {
    key: "deleteAllRegions",
    value: function deleteAllRegions() {
      var _iterator = _createForOfIteratorHelper(this.regions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var region = _step.value;
          region.removeStyles();
          region.node.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.regions = [];
      this.menu.hide();
    }
  }, {
    key: "toggleRegionVisibilityById",
    value: function toggleRegionVisibilityById(id) {
      var region = this.lookupRegionByID(id);

      if (region != null) {
        if (region.isVisible) {
          region.hide();
        } else {
          region.show();
        }
      }
    }
  }, {
    key: "unhideAllRegions",
    value: function unhideAllRegions() {
      this.regions.forEach(function (region) {
        return region.show();
      });
    }
    /**
     * Updates tags of the specified region.
     * @param id - The `id` of the region to update.
     * @param tagsDescriptor - The new tags descriptor object.
     */

  }, {
    key: "updateTagsById",
    value: function updateTagsById(id, tagsDescriptor) {
      var region = this.lookupRegionByID(id);

      if (region != null) {
        region.updateTags(tagsDescriptor, this.tagsUpdateOptions);
      }
    }
    /**
     * Updates tags for all selected regions.
     * @param tagsDescriptor - The new tags descriptor object.
     */

  }, {
    key: "updateTagsForSelectedRegions",
    value: function updateTagsForSelectedRegions(tagsDescriptor) {
      var _this3 = this;

      var regions = this.lookupSelectedRegions();
      regions.forEach(function (region) {
        region.updateTags(tagsDescriptor, _this3.tagsUpdateOptions);
      });
      regions.forEach(function (region) {
        region.unselect();
      });
    }
    /**
     * Selects the region specified by `id`.
     * @param id - The `id` of the region to select.
     */

  }, {
    key: "selectRegionById",
    value: function selectRegionById(id) {
      var region = this.lookupRegionByID(id);
      this.selectRegion(region);
    }
    /**
     * Resizes the manager to specified `width` and `height`.
     * @param width - The new manager width.
     * @param height - The new manager height.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      var tw = width / this.paperRect.width;
      var th = height / this.paperRect.height;
      this.paperRect.resize(width, height);
      this.menu.hide(); // recalculate size/position for all regions;

      var _iterator2 = _createForOfIteratorHelper(this.regions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var region = _step2.value;
          region.move(new Point2D_1.Point2D(region.x * tw, region.y * th));
          region.resize(region.boundRect.width * tw, region.boundRect.height * th);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Freezes the manager and all its current regions.
     * @param nuance - [optional] Additional css-class to add to the manager.
     */

  }, {
    key: "freeze",
    value: function freeze(nuance) {
      this.regionManagerLayer.addClass("frozen");

      if (nuance !== undefined) {
        this.regionManagerLayer.addClass(nuance);
        this.frozenNuance = nuance;
      } else {
        this.frozenNuance = "";
      }

      this.menu.hide();
      this.regions.forEach(function (region) {
        region.freeze();
      });
      this.isFrozenState = true;
    }
    /**
     * Unfreezes the manager and all its regions.
     */

  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.regionManagerLayer.removeClass("frozen");

      if (this.frozenNuance !== "") {
        this.regionManagerLayer.removeClass(this.frozenNuance);
      }

      var selectedRegions = this.lookupSelectedRegions();

      if (selectedRegions.length > 0) {
        this.menu.showOnRegion(selectedRegions[0]);
      }

      this.regions.forEach(function (region) {
        region.unfreeze();
      });
      this.isFrozenState = false;
    }
    /**
     * Toggles freezing mode.
     */

  }, {
    key: "toggleFreezeMode",
    value: function toggleFreezeMode() {
      if (this.isFrozen) {
        this.unfreeze();
      } else {
        this.freeze();
      }
    }
    /**
     * Changes the tags drawing setting to draw background or make it transparent.
     */

  }, {
    key: "toggleBackground",
    value: function toggleBackground() {
      var _this4 = this;

      this.tagsUpdateOptions.showRegionBackground = !this.tagsUpdateOptions.showRegionBackground;
      this.regions.forEach(function (r) {
        r.updateTags(r.tags, _this4.tagsUpdateOptions);
      });
    }
  }, {
    key: "transform",
    value: function transform(scale, dx, dy) {
      var _this5 = this;

      // translate immer zuerst, da es scale-abhängig ist, sprich translate 30 nach dem scale 1.1 wird zu 33
      this.currentRegionTransformation = "translate(".concat(dx, " ").concat(dy, ") scale(").concat(scale, " ").concat(scale, ")");
      this.regions.forEach(function (r) {
        r.node.transform(_this5.currentRegionTransformation);
      });
    }
    /**
     * Finds the region by specified `id`.
     * @param id - The `id` to look for.
     */

  }, {
    key: "lookupRegionByID",
    value: function lookupRegionByID(id) {
      var region = null;
      var i = 0;

      while (i < this.regions.length && region == null) {
        if (this.regions[i].ID === id) {
          region = this.regions[i];
        }

        i++;
      }

      return region;
    }
    /**
     * Internal helper function to sort regions by their area.
     */

  }, {
    key: "sortRegionsByArea",
    value: function sortRegionsByArea() {
      function quickSort(arr, left, right) {
        var pivot;
        var partitionIndex;

        if (left < right) {
          pivot = right;
          partitionIndex = partition(arr, pivot, left, right); // sort left and right

          quickSort(arr, left, partitionIndex - 1);
          quickSort(arr, partitionIndex + 1, right);
        }

        return arr;
      }

      function partition(arr, pivot, left, right) {
        var pivotValue = arr[pivot].area;
        var partitionIndex = left;

        for (var i = left; i < right; i++) {
          if (arr[i].area > pivotValue) {
            swap(arr, i, partitionIndex);
            partitionIndex++;
          }
        }

        swap(arr, right, partitionIndex);
        return partitionIndex;
      }

      function swap(arr, i, j) {
        var temp = arr[i];
        arr[i] = arr[j];
        arr[j] = temp;
      }

      var length = this.regions.length;

      if (length > 1) {
        quickSort(this.regions, 0, this.regions.length - 1);
      }
    }
    /**
     * Finds all selected regions.
     */

  }, {
    key: "lookupSelectedRegions",
    value: function lookupSelectedRegions() {
      var collection = Array();

      var _iterator3 = _createForOfIteratorHelper(this.regions),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var region = _step3.value;

          if (region.isSelected) {
            collection.push(region);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return collection;
    }
    /**
     * Deletes provided region.
     * @param region - The region to delete.
     */

  }, {
    key: "deleteRegion",
    value: function deleteRegion(region) {
      // remove style
      region.removeStyles(); // remove element

      region.node.remove();
      this.regions = this.regions.filter(function (r) {
        return r !== region;
      });
      this.menu.hide();
      this.callbacks.onRegionDelete(region.ID, region.regionData);
    }
    /**
     * Deletes all selected regions.
     */

  }, {
    key: "deleteSelectedRegions",
    value: function deleteSelectedRegions() {
      var collection = this.lookupSelectedRegions();

      var _iterator4 = _createForOfIteratorHelper(collection),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var region = _step4.value;
          this.deleteRegion(region);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this.selectNextRegion();
      this.callbacks.onManipulationEnd();
    }
    /**
     * Selects specified region.
     * @param region - The region to select.
     */

  }, {
    key: "selectRegion",
    value: function selectRegion(region) {
      if (region !== null) {
        this.unselectRegions(region);
        region.select();
        this.menu.showOnRegion(region);
        this.callbacks.onRegionSelected(region.ID);
      }
    }
    /**
     * Selects all the regions.
     */

  }, {
    key: "selectAllRegions",
    value: function selectAllRegions() {
      var r = null;

      var _iterator5 = _createForOfIteratorHelper(this.regions),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var region = _step5.value;
          r = region;
          r.select();
          this.callbacks.onRegionSelected(r.ID);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (r != null) {
        this.menu.showOnRegion(r);
      }
    }
    /**
     * Selects the next region (based on current order, e.g., sorted by area).
     */

  }, {
    key: "selectNextRegion",
    value: function selectNextRegion() {
      var region = null;
      var i = 0;
      var length = this.regions.length;

      if (length === 1) {
        region = this.regions[0];
      } else if (length > 1) {
        while (i < length && region == null) {
          if (this.regions[i].isSelected) {
            region = i === length - 1 ? this.regions[0] : this.regions[i + 1];
          }

          i++;
        }
      }

      if (region == null && length > 0) {
        region = this.regions[0];
      }

      this.selectRegion(region);
    }
    /**
     * Moves or changes region size
     * @param region - The region to be changed.
     * @param dx - x-coordinate shift.
     * @param dy - y-coordinate shift.
     * @param dw - width-shift.
     * @param dh - height-shift.
     * @param inverse - flag if the change is inverted.
     */

  }, {
    key: "reshapeRegion",
    value: function reshapeRegion(region, dx, dy, dw, dh) {
      var inverse = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var w;
      var h;
      var x;
      var y;

      if (!inverse) {
        w = region.boundRect.width + Math.abs(dw);
        h = region.boundRect.height + Math.abs(dh);
        x = region.x + dx + (dw > 0 ? 0 : dw);
        y = region.y + dy + (dh > 0 ? 0 : dh);
      } else {
        w = Math.max(0, region.boundRect.width - Math.abs(dw));
        h = Math.max(0, region.boundRect.height - Math.abs(dh));
        x = region.x + dx + (dw < 0 ? 0 : dw);
        y = region.y + dy + (dh < 0 ? 0 : dh);
      }

      var p1 = new Point2D_1.Point2D(x, y).boundToRect(this.paperRect);
      var p2 = new Point2D_1.Point2D(x + w, y + h).boundToRect(this.paperRect);
      region.move(p1);
      region.resize(p2.x - p1.x, p2.y - p1.y);
    }
    /**
     * Moves the selected region with specified shift in coordinates
     * @param dx - x-coordinate shift.
     * @param dy - y-coordinate shift.
     */

  }, {
    key: "moveSelectedRegions",
    value: function moveSelectedRegions(dx, dy) {
      var _this6 = this;

      var regions = this.lookupSelectedRegions();
      regions.forEach(function (r) {
        _this6.reshapeRegion(r, dx, dy, 0, 0);
      });
      this.menu.showOnRegion(regions[0]);
    }
    /**
     * Resizes the selected region with specified width and height shifts.
     * @param dw - width-shift.
     * @param dh - height-shift.
     * @param inverse - flag if the change is inverted.
     */

  }, {
    key: "resizeSelectedRegions",
    value: function resizeSelectedRegions(dw, dh) {
      var _this7 = this;

      var inverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var regions = this.lookupSelectedRegions();
      regions.forEach(function (r) {
        _this7.reshapeRegion(r, 0, 0, dw, dh, inverse);
      });
      this.menu.showOnRegion(regions[0]);
    }
    /**
     * The callback function fot internal components.
     * @param component - Reference to the UI component.
     * @param regionData - New RegionData object.
     * @param state - New state of the region.
     * @param multiSelection - Flag for multiselection.
     */

  }, {
    key: "onRegionChange",
    value: function onRegionChange(region, regionData, state) {
      var multiSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      // resize or drag begin
      if (state === IRegionCallbacks_1.ChangeEventType.MOVEBEGIN) {
        if (!multiSelection) {
          this.unselectRegions(region);
        }

        this.menu.hide();
        this.callbacks.onRegionSelected(region.ID, multiSelection);
        this.callbacks.onRegionMoveBegin(region.ID, regionData);
        this.justManipulated = false; // resizing or dragging
      } else if (state === IRegionCallbacks_1.ChangeEventType.MOVING) {
        this.callbacks.onRegionMove(region.ID, regionData);
        this.justManipulated = true; // resize or drag end
      } else if (state === IRegionCallbacks_1.ChangeEventType.MOVEEND) {
        if (this.justManipulated) {
          region.select();
          this.menu.showOnRegion(region);
          this.sortRegionsByArea();
          this.redrawAllRegions();
          this.callbacks.onRegionMoveEnd(region.ID, regionData);
        }
      } else if (state === IRegionCallbacks_1.ChangeEventType.SELECTIONTOGGLE && !this.justManipulated) {
        // select
        if (!region.isSelected) {
          if (!multiSelection) {
            this.unselectRegions(region);
          }

          region.select();
          this.menu.showOnRegion(region);
          this.callbacks.onRegionSelected(region.ID, multiSelection); // unselect
        } else {
          region.unselect();
          this.menu.hide();
          this.callbacks.onRegionSelected("", multiSelection);
        }
      }
    }
    /**
     * Unselects all the regions, naybe except the one specified.
     * @param except - Region to ignore.
     */

  }, {
    key: "unselectRegions",
    value: function unselectRegions(except) {
      var _iterator6 = _createForOfIteratorHelper(this.regions),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var region = _step6.value;

          if (region !== except) {
            region.unselect();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    /**
     * Inits regions manager UI.
     * @param paper - The `Snap.Paper` element to draw on.
     */

  }, {
    key: "buildOn",
    value: function buildOn(paper) {
      var _this8 = this;

      this.regionManagerLayer = paper.g();
      this.regionManagerLayer.addClass("regionManager");
      this.menuLayer = paper.g();
      this.menuLayer.addClass("menuManager");
      this.menu = new RegionMenu_1.MenuElement(paper, this.paperRect, new RegionData_1.RegionData(0, 0, 0, 0), this.callbacks);
      this.menu.addAction("delete", "trash", function (region) {
        _this8.deleteRegion(region);

        _this8.menu.hide();
      });
      this.menuLayer.add(this.menu.menuGroup);
      this.menu.hide();
    }
    /**
     * Helper function to subscribe manager to pointer and keyboard events.
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents() {
      var _this9 = this;

      this.regionManagerLayer.node.addEventListener("pointerenter", function (e) {
        _this9.callbacks.onManipulationBegin();
      });
      this.regionManagerLayer.node.addEventListener("pointerleave", function (e) {
        _this9.callbacks.onManipulationEnd();
      });
      window.addEventListener("keyup", function (e) {
        if (!(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement) && !(e.target instanceof HTMLSelectElement)) {
          if (!_this9.isFrozen) {
            switch (e.keyCode) {
              // tab
              case 9:
                _this9.selectNextRegion();

                break;
              // delete, backspace

              case 46:
              case 8:
                _this9.deleteSelectedRegions();

                break;
              // ctrl + up

              case 38:
                if (e.ctrlKey) {
                  if (!e.shiftKey && !e.altKey) {
                    _this9.moveSelectedRegions(0, -5);
                  } else if (e.shiftKey && !e.altKey) {
                    _this9.resizeSelectedRegions(0, -5);
                  } else if (e.altKey && !e.shiftKey) {
                    _this9.resizeSelectedRegions(0, -5, true);
                  }
                }

                break;
              // ctrl + down

              case 40:
                if (e.ctrlKey) {
                  if (!e.shiftKey && !e.altKey) {
                    _this9.moveSelectedRegions(0, 5);
                  } else if (e.shiftKey && !e.altKey) {
                    _this9.resizeSelectedRegions(0, 5);
                  } else if (e.altKey && !e.shiftKey) {
                    _this9.resizeSelectedRegions(0, 5, true);
                  }
                }

                break;
              // ctrl + left

              case 37:
                if (e.ctrlKey) {
                  if (!e.shiftKey && !e.altKey) {
                    _this9.moveSelectedRegions(-5, 0);
                  } else if (e.shiftKey && !e.altKey) {
                    _this9.resizeSelectedRegions(-5, 0);
                  } else if (e.altKey && !e.shiftKey) {
                    _this9.resizeSelectedRegions(-5, 0, true);
                  }
                }

                break;
              // ctrl + right

              case 39:
                if (e.ctrlKey) {
                  if (!e.shiftKey && !e.altKey) {
                    _this9.moveSelectedRegions(5, 0);
                  } else if (e.shiftKey && !e.altKey) {
                    _this9.resizeSelectedRegions(5, 0);
                  } else if (e.altKey && !e.shiftKey) {
                    _this9.resizeSelectedRegions(5, 0, true);
                  }
                }

                break;
              // default

              default:
                return;
            }

            e.preventDefault();
          }
        }
      });
      window.addEventListener("keydown", function (e) {
        if (!(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement) && !(e.target instanceof HTMLSelectElement)) {
          if (!_this9.isFrozen) {
            switch (e.code) {
              // ctrl + A, ctrl + a
              case "KeyA":
              case "Numpad1":
                if (e.ctrlKey) {
                  _this9.selectAllRegions();
                }

                break;
            } // e.preventDefault();

          }
        }
      });
    }
    /**
     * Registers the provided region in the manager.
     * @param region - The new region to register.
     */

  }, {
    key: "registerRegion",
    value: function registerRegion(region) {
      this.unselectRegions();
      region.select();
      this.regionManagerLayer.add(region.node);
      this.regions.push(region);
      this.menu.showOnRegion(region);
    }
    /**
     * Wraps provided function into a checker that it exists
     * @param f - Function to wrap
     */

  }, {
    key: "functionGuard",
    value: function functionGuard(f) {
      return function () {
        if (typeof f === "function") {
          f.apply(void 0, arguments);
        }
      };
    }
  }, {
    key: "isFrozen",
    get: function get() {
      return this.isFrozenState;
    }
  }]);

  return RegionsManager;
}();

exports.RegionsManager = RegionsManager;